import { useEffect } from 'react';
import ContainerComponent from '@/components/common/notes/show-note-forms/form-components/container-component';
import { SET_VALUE } from '@/components/common/notes/show-note-forms/dataToSendReducer';
import Input from '@mui/material/Input';

interface Props {
    value: string;
    formId: string;
    formName: string;
    formDispatch: any;
    item: {
        label: string;
        name: string;
        placeholder: string;
        required: boolean;
        description: string;
    };
    readOnly: boolean;
}

const NumberFieldComponent = ({
    value,
    formDispatch,
    formId,
    formName,
    item: { label, name: fieldId, placeholder, required, description },
    readOnly,
}: Props) => {
    useEffect(() => {
        formDispatch({ type: SET_VALUE, payload: { value, fieldId, formId } });
        formDispatch({ type: SET_VALUE, payload: { value, fieldId, formId: formName } });
    }, []);

    const handleChange = ({ target: { value } }: any) => {
        formDispatch({ type: SET_VALUE, payload: { value, fieldId, formId } });
        formDispatch({ type: SET_VALUE, payload: { value, fieldId, formId: formName } });
    };

    const regexp = new RegExp('[0-9]|Backspace|ArrowLeft|ArrowRight|ArrowUp|ArrowDown|Delete');

    return (
        <ContainerComponent label={label} required={required} description={description}>
            <Input
                sx={{
                    width: '100%',
                    fontFamily: "'Google Sans',Roboto,Arial,sans-serif",
                    fontSize: 14,
                }}
                placeholder={placeholder}
                value={value}
                onChange={handleChange}
                type='number'
                onKeyDown={(evt) => !regexp.test(evt.key) && evt.preventDefault()}
                disabled={readOnly}
            />
        </ContainerComponent>
    );
};

export default NumberFieldComponent;
